import { all } from 'redux-saga/effects';

import caseSaga from './case-saga';

export default function* rootSaga() {
  yield all([caseSaga()]);
}
